// Module
var code = `<div class="overlay-menu-label d-flex justify-content align-content"> <span class="overlay-menu-label__title"> {{ ctrl.label }} </span> </div> `;
// Exports
var _module_exports =code;;
var path = '/core/overlay/overlay_menu_label/overlayMenuLabel.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;